import { createFileRoute } from '@tanstack/react-router'
import { ClubsPage } from '~/features/league/ClubsPage'
import { clubsQuery } from '~/features/league/queries'
import { loaderScope } from '~/features/matches/queries'

export const Route = createFileRoute('/_app/liga/vereine/')({
  loader: async ({ context }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId || !scope.permissions.includes('matches.read')) return
    await context.queryClient.ensureQueryData(clubsQuery(scope.teamId, scope.season))
  },
  component: ClubsPage,
})
